import { render } from "./VLIndicator.vue?vue&type=template&id=94bb44f2&scoped=true"
import script from "./VLIndicator.vue?vue&type=script&lang=js"
export * from "./VLIndicator.vue?vue&type=script&lang=js"

import "./VLIndicator.vue?vue&type=style&index=0&id=94bb44f2&lang=scss&scoped=true"

import exportComponent from "/opt/sources/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94bb44f2"]])

export default __exports__